import { LOCAL_STORAGE_CUSTOM_LEVELS } from "./consts";

export const deleteLevel = (id) => {
  const localLevelsString =
    window.localStorage.getItem(LOCAL_STORAGE_CUSTOM_LEVELS) || "{}";

  const parsedCustomLevels = JSON.parse(localLevelsString);
  delete parsedCustomLevels[id];

  window.localStorage.setItem(
    LOCAL_STORAGE_CUSTOM_LEVELS,
    JSON.stringify(parsedCustomLevels)
  );

  window.location.reload();
};
